<template>
  <el-dialog title="Employee list" :width="dialogWidth" :visible.sync="visible" :close-on-click-modal="false">
    <div v-loading="form_loading">
      <el-table
        :data="tableData"
        :header-cell-style="{ fontSize: '14px', backgroundColor: '#F8F9FA',color:'#4A5468',fontWeight:'normal'}"
        :cell-style="{ fontSize: '14px'}"
        @selection-change="handleSelectionChange"
        style="width: 100%;">

        <el-table-column
              type="selection"
              width="55">
        </el-table-column>
        <el-table-column
          align="center"
          prop="employee_name"
          label="Name">
        </el-table-column>

        <el-table-column
          align="center"
          label="Position">
          <template slot-scope="scope">
            {{scope.row.employee_position}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="dialog-footer" style="display: flex;justify-content: center;margin-top: 15px;">
      <span class="btn" style="margin-right: 10px;" @click="save_send">Confirm</span>
    </div>
  </el-dialog>

</template>

<script>
import Vue from 'vue';
import { getActionApi, postActionApi } from '@/network/manageApi';
export default {
  name: 'SelectStaffs',
  components: {},
  data() {
    return {
      dialogWidth:'600px',
      visible: false,
      form_loading: false,
      tableData: [],
      table_loading: false,
      selected_data: []
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  created() {
    this.setDialogWidth()
  },
  methods: {
    handleSelectionChange(val) {
      this.selected_data = val
    },
    getDatas() {
      this.table_loading = true
      getActionApi("/review/business-promoter/staff").then((res) => {
        this.tableData = res.data
      }).catch((err) => {
      }).finally((res) => {
        this.table_loading = false
      })
    },
    init() {
      this.visible = true
      this.tableData = []
      this.selected_data = []
      this.getDatas()
    },
    save_send() {
      if(this.selected_data.length == 0) {
        this.$message({
          message: 'Please select employee',
          type: 'warning'
        });
        return;
      }
      this.visible = false
      this.$emit('ok', this.selected_data)
    },
    setDialogWidth() {
      var val = document.body.clientWidth
      const def = 600 // default width
      if (val < def) {
        this.dialogWidth = '100%'
      } else {
        this.dialogWidth = def + 'px'
      }
    }
  }
}
</script>

<style scoped>
  .form{display: flex;flex-direction: column;}
  .form .flex{display: grid;grid-template-columns:1fr 1fr;gap: 20px;padding-bottom: 0;}
  .form .div{display: flex;flex-direction: column;color:#2D3748;font-weight: bold;padding-bottom:20px;}
  .form .div input{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;}
  .form .div select{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;box-sizing: border-box;}
  .headImage{display: flex;width: 76px;margin-top:15px;}
  .headImage .edit{display: none;padding-bottom:0;width: 76px;height: 76px;position: absolute;justify-content: center;align-items: center;background-color: rgba(0, 0, 0, 0.5);border-radius: 4px;}
  .headImage .edit span{background-color: rgba(255, 255, 255, 0.36);margin-left:0;padding:4px 10px;border-radius:4px;font-weight: bold;color:#ffffff;cursor: pointer;}
  .headImage:hover .edit{display: flex;}
  .headImage img{width: 76px;height: 76px;border-radius: 4px;}
  .default_upload {width: 76px;height: 76px;border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;display: flex;align-items: center;justify-content: center;}
  .avatar-uploader-icon {font-size: 18px;color: #8c939d;}
  .font-size-16 {font-size: 16px;}
  .margin-top-switch {margin-top: 10px;}
  .btn{height:40px;width:86px;cursor: pointer;background-color: #5856D6;color:#ffffff;border-radius: 6px;font-size: 14px;display: flex;align-items: center;justify-content: center;}
</style>
